"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountValueOccurrencesOfFields = exports.AllOfFieldsIsNumeric = exports.SumOfFields = exports.AnyOfFieldsIs = exports.Or = exports.And = exports.Not = exports.In = exports.LessThanEquals = exports.LessThan = exports.GreaterThanEquals = exports.GreaterThan = exports.NotEqual = exports.Equal = exports.ValidSAPhoneNumber = exports.ValidSAID = exports.Regex = exports.Get = exports.Multiply = exports.Divide = exports.Subtract = exports.Add = exports.Operators = void 0;
var lodash_get_1 = __importDefault(require("lodash.get"));
var validators_1 = require("../../validators");
var NullOperator = /** @class */ (function () {
    function NullOperator() {
    }
    NullOperator.evaluate = function () {
        return null;
    };
    NullOperator.op = 'null';
    NullOperator.numArgs = 0;
    return NullOperator;
}());
// tslint:disable-next-line:max-classes-per-file
var Operators = /** @class */ (function () {
    function Operators() {
    }
    Operators.find = function (operatorKey) {
        if (!(operatorKey in this.operators))
            return NullOperator;
        return this.operators[operatorKey];
    };
    Operators.register = function (operator) {
        this.operators[operator.op] = operator;
    };
    Operators.operators = {};
    return Operators;
}());
exports.Operators = Operators;
// tslint:disable-next-line:max-classes-per-file
var Add = /** @class */ (function () {
    function Add() {
    }
    Add.evaluate = function (arg1, arg2) {
        return arg1 + arg2;
    };
    Add.op = '+';
    Add.numArgs = 2;
    return Add;
}());
exports.Add = Add;
Operators.register(Add);
// tslint:disable-next-line:max-classes-per-file
var Subtract = /** @class */ (function () {
    function Subtract() {
    }
    Subtract.evaluate = function (arg1, arg2) {
        return arg1 - arg2;
    };
    Subtract.op = '-';
    Subtract.numArgs = 2;
    return Subtract;
}());
exports.Subtract = Subtract;
Operators.register(Subtract);
// tslint:disable-next-line:max-classes-per-file
var Divide = /** @class */ (function () {
    function Divide() {
    }
    Divide.evaluate = function (arg1, arg2) {
        return arg1 / arg2;
    };
    Divide.op = '/';
    Divide.numArgs = 2;
    return Divide;
}());
exports.Divide = Divide;
Operators.register(Divide);
// tslint:disable-next-line:max-classes-per-file
var Multiply = /** @class */ (function () {
    function Multiply() {
    }
    Multiply.evaluate = function (arg1, arg2) {
        return arg1 * arg2;
    };
    Multiply.op = '*';
    Multiply.numArgs = 2;
    return Multiply;
}());
exports.Multiply = Multiply;
Operators.register(Multiply);
// tslint:disable-next-line:max-classes-per-file
var Get = /** @class */ (function () {
    function Get() {
    }
    Get.evaluate = function (path, fields) {
        return lodash_get_1.default(fields, path);
    };
    Get.op = 'get';
    Get.numArgs = 1;
    Get.injectFields = true;
    return Get;
}());
exports.Get = Get;
Operators.register(Get);
// tslint:disable-next-line:max-classes-per-file
var Regex = /** @class */ (function () {
    function Regex() {
    }
    Regex.evaluate = function (arg1, arg2) {
        var re = new RegExp(arg1);
        return re.test(arg2);
    };
    Regex.op = 'regex';
    Regex.numArgs = 2;
    return Regex;
}());
exports.Regex = Regex;
Operators.register(Regex);
// tslint:disable-next-line:max-classes-per-file
var ValidSAID = /** @class */ (function () {
    function ValidSAID() {
    }
    ValidSAID.evaluate = function (arg1) {
        return validators_1.isValidSAIDNumber(arg1);
    };
    ValidSAID.op = 'valid_said';
    ValidSAID.numArgs = 1;
    return ValidSAID;
}());
exports.ValidSAID = ValidSAID;
Operators.register(ValidSAID);
// tslint:disable-next-line:max-classes-per-file
var ValidSAPhoneNumber = /** @class */ (function () {
    function ValidSAPhoneNumber() {
    }
    ValidSAPhoneNumber.evaluate = function (arg1) {
        return validators_1.isValidTelephoneNumber(arg1);
    };
    ValidSAPhoneNumber.op = 'valid_sa_phone_number';
    ValidSAPhoneNumber.numArgs = 1;
    return ValidSAPhoneNumber;
}());
exports.ValidSAPhoneNumber = ValidSAPhoneNumber;
Operators.register(ValidSAPhoneNumber);
// tslint:disable-next-line:max-classes-per-file
var Equal = /** @class */ (function () {
    function Equal() {
    }
    Equal.evaluate = function (arg1, arg2) {
        return arg1 === arg2; // Use strict equality
    };
    Equal.op = '=';
    Equal.numArgs = 2;
    return Equal;
}());
exports.Equal = Equal;
Operators.register(Equal);
// tslint:disable-next-line:max-classes-per-file
var NotEqual = /** @class */ (function () {
    function NotEqual() {
    }
    NotEqual.evaluate = function (arg1, arg2) {
        return arg1 !== arg2; // Use strict equality
    };
    NotEqual.op = '!=';
    NotEqual.numArgs = 2;
    return NotEqual;
}());
exports.NotEqual = NotEqual;
Operators.register(NotEqual);
// tslint:disable-next-line:max-classes-per-file
var GreaterThan = /** @class */ (function () {
    function GreaterThan() {
    }
    GreaterThan.evaluate = function (arg1, arg2) {
        return arg1 > arg2;
    };
    GreaterThan.op = '>';
    GreaterThan.numArgs = 2;
    return GreaterThan;
}());
exports.GreaterThan = GreaterThan;
Operators.register(GreaterThan);
// tslint:disable-next-line:max-classes-per-file
var GreaterThanEquals = /** @class */ (function () {
    function GreaterThanEquals() {
    }
    GreaterThanEquals.evaluate = function (arg1, arg2) {
        return arg1 >= arg2;
    };
    GreaterThanEquals.op = '>=';
    GreaterThanEquals.numArgs = 2;
    return GreaterThanEquals;
}());
exports.GreaterThanEquals = GreaterThanEquals;
Operators.register(GreaterThanEquals);
// tslint:disable-next-line:max-classes-per-file
var LessThan = /** @class */ (function () {
    function LessThan() {
    }
    LessThan.evaluate = function (arg1, arg2) {
        return arg1 < arg2;
    };
    LessThan.op = '<';
    LessThan.numArgs = 2;
    return LessThan;
}());
exports.LessThan = LessThan;
Operators.register(LessThan);
// tslint:disable-next-line:max-classes-per-file
var LessThanEquals = /** @class */ (function () {
    function LessThanEquals() {
    }
    LessThanEquals.evaluate = function (arg1, arg2) {
        return arg1 <= arg2;
    };
    LessThanEquals.op = '<=';
    LessThanEquals.numArgs = 2;
    return LessThanEquals;
}());
exports.LessThanEquals = LessThanEquals;
Operators.register(LessThanEquals);
// tslint:disable-next-line:max-classes-per-file
var In = /** @class */ (function () {
    function In() {
    }
    In.evaluate = function (value, arr) {
        return arr.includes(value);
    };
    In.op = 'in';
    In.numArgs = 2;
    return In;
}());
exports.In = In;
Operators.register(In);
// tslint:disable-next-line:max-classes-per-file
var Not = /** @class */ (function () {
    function Not() {
    }
    Not.evaluate = function (value) {
        return !value;
    };
    Not.op = '!';
    Not.numArgs = 1;
    return Not;
}());
exports.Not = Not;
Operators.register(Not);
// tslint:disable-next-line:max-classes-per-file
var And = /** @class */ (function () {
    function And() {
    }
    And.evaluate = function (arg1, arg2) {
        return arg1 && arg2;
    };
    And.op = '&';
    And.numArgs = 2;
    return And;
}());
exports.And = And;
Operators.register(And);
// tslint:disable-next-line:max-classes-per-file
var Or = /** @class */ (function () {
    function Or() {
    }
    Or.evaluate = function (arg1, arg2) {
        return arg1 || arg2;
    };
    Or.op = '|';
    Or.numArgs = 2;
    return Or;
}());
exports.Or = Or;
Operators.register(Or);
// tslint:disable-next-line:max-classes-per-file
var AnyOfFieldsIs = /** @class */ (function () {
    function AnyOfFieldsIs() {
    }
    AnyOfFieldsIs.evaluate = function (value, pathList, fields) {
        var valuesToTest = pathList.map(function (path) { return lodash_get_1.default(fields, path); });
        return valuesToTest.some(function (testValue) { return testValue === value; });
    };
    AnyOfFieldsIs.op = 'any_of_fields_is';
    AnyOfFieldsIs.numArgs = 2;
    AnyOfFieldsIs.injectFields = true;
    return AnyOfFieldsIs;
}());
exports.AnyOfFieldsIs = AnyOfFieldsIs;
Operators.register(AnyOfFieldsIs);
// tslint:disable-next-line:max-classes-per-file
var SumOfFields = /** @class */ (function () {
    function SumOfFields() {
    }
    SumOfFields.evaluate = function (pathList, fields) {
        var valuesToAdd = pathList.map(function (path) { return lodash_get_1.default(fields, path); });
        return valuesToAdd.reduce(function (a, b) {
            return a + b;
        }, 0);
    };
    SumOfFields.op = 'sum_of_fields';
    SumOfFields.numArgs = 1;
    SumOfFields.injectFields = true;
    return SumOfFields;
}());
exports.SumOfFields = SumOfFields;
Operators.register(SumOfFields);
// tslint:disable-next-line:max-classes-per-file
var AllOfFieldsIsNumeric = /** @class */ (function () {
    function AllOfFieldsIsNumeric() {
    }
    AllOfFieldsIsNumeric.evaluate = function (pathList, fields) {
        var valuesToTest = pathList.map(function (path) { return lodash_get_1.default(fields, path); });
        return valuesToTest.every(function (value) { return typeof value === 'number'; });
    };
    AllOfFieldsIsNumeric.op = 'all_of_fields_is_numeric';
    AllOfFieldsIsNumeric.numArgs = 1;
    AllOfFieldsIsNumeric.injectFields = true;
    return AllOfFieldsIsNumeric;
}());
exports.AllOfFieldsIsNumeric = AllOfFieldsIsNumeric;
Operators.register(AllOfFieldsIsNumeric);
// tslint:disable-next-line:max-classes-per-file
var CountValueOccurrencesOfFields = /** @class */ (function () {
    function CountValueOccurrencesOfFields() {
    }
    CountValueOccurrencesOfFields.evaluate = function (searchValue, pathList, fields) {
        var valuesToTest = pathList.map(function (path) { return lodash_get_1.default(fields, path); });
        return valuesToTest.reduce(function (n, val) { return n + (val === searchValue); }, 0);
    };
    CountValueOccurrencesOfFields.op = 'count_value_occurrences_of_fields';
    CountValueOccurrencesOfFields.numArgs = 2;
    CountValueOccurrencesOfFields.injectFields = true;
    return CountValueOccurrencesOfFields;
}());
exports.CountValueOccurrencesOfFields = CountValueOccurrencesOfFields;
Operators.register(CountValueOccurrencesOfFields);
